import { useGenericStore } from '@/store';
import { useAuth } from '@/contexts/Auth';
import { clearMixpanel, logEvent } from '@/helpers/analytics';
import { useEffect } from 'react';
import { useNavigate } from '@tanstack/react-router';

const Logout = () => {
  const { resetStore } = useGenericStore();
  const { logout, user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const doLogout = async () => {
      try {
        // Log logout event before clearing analytics
        logEvent('logout');

        // Clear analytics data
        clearMixpanel();

        // Clear stores
        resetStore();

        // Logout via AuthContext - this clears cookies and updates the auth state
        await logout();
      } catch (_) {
        // Ignore errors
      }
    };

    // Only run logout if user is still authenticated
    if (user) {
      doLogout();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- deps intentionally omitted to avoid re-running
  }, []);

  // After logout (user becomes null), redirect to login
  useEffect(() => {
    if (!user) {
      navigate({ to: '/login', replace: true });
    }
  }, [user, navigate]);

  return null;
};

export default Logout;
